export interface SchoolPluginScopeInterface {
  ids: number[]
  studentIds: number[]
  teacherIds: number[]
}

export class SchoolPluginScope implements SchoolPluginScopeInterface {
  ids: number[]
  studentIds: number[]
  teacherIds: number[]

  constructor(props: SchoolPluginScopeInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      ids: _ids,
      studentIds: _studentIds,
      teacherIds: _teacherIds,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.ids = _ids
    this.studentIds = _studentIds
    this.teacherIds = _teacherIds
  }
}
